import React, { Component } from 'react';
import OpenApp from "react-open-app";
import { connect } from 'react-redux';

class Door extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header text-muted font-weight-bold text-uppercase ">
                ทางเข้า STARVEGAS
              </div>
              <ui className="list-group list-group-flush color-hover">
                <li className="list-group-item text-muted text-center" type="text">
                  <OpenApp
                    className="btn btn-gclub col-12 text-white"
                    href="https://member.starvegas88888vip.com"
                    android={`lobbystarvegas://lobbystarvegas?account=${this.props.game?.gameAccounts[0].gameUsername}&password=${this.props.game?.gameAccounts[0].gamePassword}`}
                    // android={`lobbystarvegas://lobbystarvegas?account=sv885762&password=Hd665544`}
                    ios={`lobbystarvegas://lobbystarvegas?account=${this.props.game?.gameAccounts[0].gameUsername}&password=${this.props.game?.gameAccounts[0].gamePassword}`}
                  >
                    เล่นที่นี้
                </OpenApp>
                <br/>
                  <span className="text-danger">**กรุณาลงแอพพลิเคชั่นก่อนกดนะคะ**</span>
                </li>
                <li className="list-group-item text-muted" type="text">
                  <button
                    className="btn btn-gclub col-12 text-white"
                    onClick={() =>
                      window.open('https://www.starvegas88888vip.com/download.php', '_blank')
                    }
                  >
                    วิธีการลงแอพพลิเคชั่น
                  </button>
                </li>
                <li className="list-group-item text-muted" type="text">
                  <button
                    className="btn btn-gclub col-12 text-white"
                    onClick={() =>
                      window.open('https://www.starvegas88888vip.com/%E0%B8%A7%E0%B8%B4%E0%B8%98%E0%B8%B5%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%A5%E0%B9%88%E0%B8%99.php', '_blank')
                    }
                  >
                    วิธีการเล่น
                  </button>
                </li>
              </ui>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  game: state.game.dataGame?.datas,
});

export default connect(mapStateToProps)(Door);
